import {CrmSystemState, CrmSystemTypes} from "./actionsTypes";

export const INIT_STATE: CrmSystemState = {
    data: [],
    item: null,

    pagination: {},
    error: {},
    loading: false,
    loaded: false,

    isOpenModal: false,
}

const crmSystem = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case CrmSystemTypes.GET_CRM_SYSTEMS:
            return {
                ...state,
                loading: true
            }

        case CrmSystemTypes.GET_CRM_SYSTEMS_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                pagination: action.payload.pagination,
                loaded: true,
                loading: false
            }

        case CrmSystemTypes.GET_CRM_SYSTEM_SUCCESS:
            return {
                ...state,
                item: action.payload,
            }

        case CrmSystemTypes.ADD_CRM_SYSTEM_SUCCESS:
            return {
                ...state,
                data: [action.payload, ...state.data],
            }


        case CrmSystemTypes.UPDATE_CRM_SYSTEM_SUCCESS:
            const items = state.data.map((item) =>
                (item.id === action.payload.id) ? action.payload : item
            )

            return {
                ...state,
                data: items,
                error: {},
                loading: false,
                loaded: true
            }

        case CrmSystemTypes.DELETE_CRM_SYSTEM_SUCCESS:
            return {
                ...state,
                data: state.data.filter(item => item.id !== action.payload),
            }

        case CrmSystemTypes.FAIL_CRM_SYSTEMS:
            return {
                ...state,
                error: action.payload,
                loaded: false,
                loading: false
            }

        case CrmSystemTypes.CLEAR_CRM_SYSTEM:
            return {
                ...state,
                item: null,
                error: {}
            }

        case CrmSystemTypes.CLEAR_CRM_SYSTEMS:
            return INIT_STATE;

        case CrmSystemTypes.MODAL_CRM_SYSTEM:
            return {
                ...state,
                isOpenModal: action.status,
            }

        default:
            return state
    }
}

export default crmSystem